export default "__VITE_ASSET__Qb6noX19__"